import { html } from 'lit';
import '../elements/d-label.js';
import { customElement, property } from 'lit/decorators.js';
import { DViewText } from 'src/library/fields/d-view-text';
import type { Assignee, PronounForm } from 'src/library/fields/assignee';
import { getAssigneesAsText } from 'src/store/selectors/assignees';

/**
 *
 * STATUS OK
 */
@customElement('d-view-assignees')
export class DViewAssignees extends DViewText {
  @property({ type: Array })
  peopleAndFunctions: Assignee[] = [];
  @property({ type: Array })
  assignees: string[] = [];
  @property({ type: Boolean })
  fullNames = false;
  @property({ type: String })
  pronoun: PronounForm = undefined;

  renderContent() {
    return html`
      <slot></slot>
      <slot name="under-label"></slot>
      <span class="content"
        >${getAssigneesAsText(this.peopleAndFunctions, this.assignees, this.fullNames, this.pronoun)}</span
      >
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-view-assignees': DViewAssignees;
  }
}
